//
// Copyright (c) 2025 Comcast
//

const de = {
  'translation': {
    'common': {
      'update': 'Aktualisieren',
      'cancel': 'Stornieren',
      'submit': 'Submit (de)',
      'confirm': 'Confirm (de)',
      'confirmChanges': 'Confirm Changes (de)',
      'save': 'Save (de)',
      'send': 'Send (de)',
      'add': 'Add (de)',
      'areYouSure': 'Are you sure? (de)',
      'yes': 'Ja',
      'no': 'Nein',
      'copy': 'Copy (de)',
      'close': 'Close (de)',
      'enabled': 'enabled (de)',
      'disabled': 'disabled (de)',
      'notSelected': 'NOT SELECTED (de)',
      'breadcrumbTicketingSystems': 'Ticketing Systems (de)',
      'breadcrumbTicketingSystemsByPartner': '{{partnerName}} Ticketing Systems (de)',
      'breadcrumbTicketingSystem': 'Ticketingsystem',
      'breadcrumbTicketEdit': 'Ticket Bearbeiten',
      'breadcrumbTicketClone': 'Ticket Klonen',
      'breadcrumbTicketCreate': 'Ticket Erstellen',
      'breadcrumbTicketRequests': 'Ticket Requests (de)',
      'breadcrumbTicketsSearchResults': 'Search Results (de)',
      'breadcrumbTicketProviders': 'Ticket Providers (de)',
      'breadcrumbTicketProviderTicketBoards': 'Provider Ticket Boards (de)',
      'breadcrumbPartners': 'Partners (de)',
      'breadcrumbPartner': 'Partner (de)',
      'breadcrumbOauthApps': 'Oauth Apps (de)',
      'breadcrumbProviders': 'Providers (de)',
      'breadcrumbSatClients': 'SAT Clients (de)',
      'breadcrumbSatSecrets': 'SAT Secrets (de)',
      'breadcrumbStatusCollections': 'Status Collections (de)',
      'breadcrumbStatusCollection': 'Status Collection (de)',
      'breadcrumbPartnerStatuses': 'Partner Statuses (de)',
      'breadcrumbMimeTypeCollections': 'Mime Type Collections (de)',
      'breadcrumbMimeTypeCollection': 'Mime Type Collection (de)',
      'breadcrumbQueries': 'Queries (de)',
      'breadcrumbMimeTypes': 'MIME Types (de)',
      'breadcrumbSharedFieldsMaps': 'Shared Fields Maps (de)',
      'breadcrumbColumns': 'Columns (de)',
      'breadcrumbReleaseNotes': 'Release Notes (de)',
      'breadcrumbReleaseNotesAdd': 'Add New Release (de)',
      'breadcrumbReleaseNotesEdit': 'Edit {{releaseName}} Release (de)',
      'breadcrumbUserProfile': 'User Profile (de)',
      'breadcrumbProviderCredentials': 'Provider Credentials (de)',
      'periodMin': 'min (de)',
      'periodHour': 'h (de)',
      'periodDay': 'day (de)',
      'noChartData': 'no data (de)',
      'noTableData': 'no data (de)',
      'noTableDataWithFilterOrSearch': 'nothing found. try searching for something else or apply other filters (de)',
      'success': 'success (de)',
      'failed': 'failed (de)',
      'uploadError': 'UPLOAD ERROR (de)',
      'fileUploadtimeOut': 'File Upload Timed Out (de)',
      'requestTimeOut': 'Request Timed Out (de)',
      'multiSelectItemCount_one': '{{count}} item (de)',
      'multiSelectItemCount_other': '{{count}} items (de)',
      'inheritedFromProvider': 'INHERITED FROM PROVIDER (de)',
      'typeHere': 'Type here (de)',
      'requiredField': 'required field (de)',
      'partner': 'partner (de)',
      'email': 'email (de)',
      'userName': 'user name (de)',
      'description': 'description (de)',
      'createdAt': 'created at (de)',
      'updatedAt': 'updated at (de)',
      'downloadCsv': 'Download CSV (de)',
      'exportToCsv': 'Export to CSV (de)',
      'moreLink': 'More (de)',
      'tooltipCopy': 'Copy (de)',
      'tooltipCopyLink': 'Copy Link (de)',
      'tooltipCopied': 'Copied! (de)',
      'tooltipShowMore': 'Show More (de)',
      'tooltipDownload': 'Download (de)',
      'lastReleaseNoteNotification': 'Relay {{version}} version was released. Please check release notes (de)',
      'goToReleaseNotes': 'Go to Release Notes (de)',
      'on': 'ON (de)',
      'off': 'OFF (de)',
      'confirmationInfoLine': 'Following changes will be submitted: (de)',
      'sortedBy': 'Sorted by (de)',
      'justificationInfoLine': 'Bitte fügen Sie eine Begründung für die Änderung der folgenden Felder hinzu:',
      'justificationInfoLineShort': 'Please add a justification for changing: (de)',
      'viewSecureInfo': 'View Secure Info (de)',
      'hideSecureInfo': 'Hide Secure Info (de)',
      'sortTicketIdLabel': 'Ticket Id (de)',
      'loading': 'Loading...(de)',
    },
    'commonNotifications': {
      'timezoneChangeDetected': 'We\'ve detected you\'ve updated your time zone {{- timezone}}. Would you like to update your Relay time zone? (de)',
      'timezoneChangeApproved': 'Your Relay time zone was automtically updated to {{- timezone}} (de)',
      'updateProfile': 'Update Profile (de)',
    },
    'commonTooltips': {
      'tooltipAudit': 'Open Audit (de)',
      'exportConfig': 'Export Config (de)',
      'settings': 'Settings (de)',
    },
    'profilePage': {
      'firstName': 'Vorname',
      'lastName': 'Nachname',
      'timeZone': 'Zeitzone',
      'email': 'Email',
      'role': 'Role',
      'capability': 'Capability (de)',
      'partner': 'Partner',
      'locale': 'Language',
      'autoSubscribe': 'Auto Subscribe to my tickets (de)',
      'subscribeToNewReleases': 'Subscribe to Relay release notes (de)',
      'dashboard': 'Dashboard',
      'switcherText1': 'Erstelle & verfolge Tickets',
      'switcherText2': 'Monitor Integration',
      'switcherTooltip1': 'Einreichen und managen von Service Management Tickets',
      'switcherTooltip2': 'Zugriff auf Statistiken, Fehleranalyse und Bonding Health',
      'avatarChange': 'veränderung',
      'useTimeFormat24': 'Time format (de)',
      'time24Hour': '24-hour time (de)',
      'timezoneAutodetect': 'Automatically detect time zone (de)',
      'myAccount': 'My Account (de)',
      'myPreferences': 'My Preferences (de)',
      'subscribeToNewTickets': 'Subscribe to new tickets (de)',
      'mySubscriptions': 'My Subscriptions (de)',
      'defaultImage': 'Default Image (de)',
      'openFile': 'Open File (de)',
    },
    'footer': {
      'releaseVersion': 'Release version (de)',
      'hash': 'Hash (de)',
      'deployedAt': 'Deployed at (de)',
    },
    'header': {
      'lastUpdate': 'Letztes Update',
    },
    'mainHeader': {
      'partners': 'Partner',
      'users': 'Benutzer',
      'audit': 'Prüfung',
      'auditAll': 'Alle Partner Aktivitäten',
      'auditUsers': 'Nutzer Aktivitäten',
      'auditIntegration': 'Integration Aktivitiäten',
      'auditAdmin': 'Admin Aktivitäten',
      'sentEmails': 'Gesendete Emails',
      'configuration': 'Configuration (de)',
      'configTicketProviders': 'Ticket Providers (de)',
      'configStatusCollections': 'Status Collections (de)',
      'configMimeTypeCollections': 'Mime Type Collections (de)',
      'configSharedMaps': 'Shared Fields Maps (de)',
      'configMimeTypes': 'MIME Types (de)',
      'configTicketingSystems': 'Ticketing Systems (de)',
      'configQueries': 'Queries (de)',
      'configProviderTicketBoards': 'Ticket Boards (de)',
      'configSectionPartner': 'Partner (de)',
      'configSectionEngine': 'Engine (de)',
      'configSectionOtherSettings': 'Other Settings (de)',
      'configSectionInternal': 'Internal (de)',
      'configSectionAuthentication': 'Authentication (de)',
      'featureFlags': 'Feature Flags (de)',
      'requests': 'Requests_(de)',
      'requestsPartner': 'Partner Requests (de)',
      'requestsInternal': 'Internal Communications (de)',
      'requestsProxy': 'Proxy Communications (de)',
      'reports': 'Reports (de)',
      'reportsUsers': 'Users (de)',
      'reportsUserFilters': 'User Filters (de)',
      'reportsSubscriptions': 'Subscriptions (de)',
      'reportsFeedback': 'Feedback (de)',
      'partnersNewTicket': 'New ticket (de)',
      'tickets': 'Tickets_(de)',
      'ticketsSectionPartner': 'Partner (de)',
      'ticketsSectionProvider': 'Provider (de)',
      'ticketsSectionProviders': 'Providers (de)',
      'about': 'About_(de)',
      'aboutReleaseNotes': 'Release Notes (de)',
      'aboutApiDocumentation': 'API Documentation (de)',
      'userProfile': 'My Profile (de)',
      'userSatClients': 'SAT Management (de)',
      'userSubscriptions': 'My Subscriptions (de)',
      'userSignOut': 'Sign Out (de)',
      'userSignOutTitle': 'SIGN OUT (de)',
      'userSignOutConfirm': 'Are you sure you want to sign out? (de)',
      'filteredBy': 'Filtered by: (de)',
      'searchPlaceholder': 'Search text in tickets... (de)',
      'webhookEvents': 'Webhook Events (de)',
      'asyncJobs': 'Async Jobs (de)',
      'maintenanceTasks': 'Maintenance Tasks (de)',
      'databasePerformance': 'Database Performance (de)',
      'satClients': 'Sat Clients (de)',
      'providerCredentials': 'Provider Credentials (de)',
      'globalSearch': {
        'placeholder': 'Search text in tickets... (de)',
        'noResults': 'no results (de)',
        'exactMatch': 'EXACT MATCH (de)',
        'suggested': 'SUGGESTED (de)',
        'viewAllResults': 'View all results (de)',
      },
    },
    'apiDocPage': {
      'pageTitle': 'API Documentation (de)',
      'title': 'OpenApi Specification (de)',
      'download': 'Download OpenApi Spec (de)',
      'rebuildCache': 'Refresh API Doc Cache (de)',
    },
    'dashboardPage': {
      'pageTitle': 'Dashboard (de)',
      'greeting': 'Hello (de)',
      'signedAs': 'You signed as (de)',
      'summaryTab': 'Summary (de)',
      'last24Hours': 'Last 24 hours (de)',
      'last48Hours': 'Last 48 hours (de)',
      'last7Days': 'Last 7 days (de)',
      'last30Days': 'Last 30 days (de)',
      'bonded': 'bonded (de)',
      'unbonded': 'unbonded (de)',
      'created': 'created (de)',
      'closed': 'closed (de)',
      'open': 'open (de)',
      'activeTickets': 'active tickets (de)',
      'activeUsers': 'active users (de)',
      'withSubscriptions': 'with subscriptions (de)',
      'moreLink': 'More (de)',
      'bondedVsUnbondedTooltip': 'A widget shows count of all tickets\nby all time of bonded and unbonded ones (de)',
      'bondedVsUnbonded': 'bonded vs. unbonded (de)',
      'createdVsClosedTooltip': 'A widget shows count of all tickets\nwhich were created and closed by all time (de)',
      'createdVsClosed': 'created vs. closed (de)',
      'httpCodeRequestTooltip': 'A widget shows count of all requests\ngrouped by response code (de)',
      'httpCodeRequest': 'http code requests (de)',
      'recentTicketsTooltip': 'Latest created tickets (de)',
      'recentTicketsHeader': 'recent tickets (de)',
      'lastTicketSuccess': 'last ticket success (de)',
      'lastTicketFail': 'last ticket fail (de)',
      'lastCommentSuccess': 'last comment success (de)',
      'lastCommentFail': 'last comment fail (de)',
      'lastAttachmentSuccess': 'last attachment success (de)',
      'lastAttachmentFail': 'last attachment fail (de)',
      'action': 'action (de)',
      'time': 'time at (de)',
      'createAction': 'create (de)',
      'updateAction': 'update (de)',
      'collectionAction': 'collection (de)',
      'recentApiRequestHeader': 'recent api requests (de)',
      'latestRequestTooltipText': "Latest partner's requests to Relay API\nfor selected Ticketing system (de)",
      'latestRequestStatusTooltipText': "Table shows date of last success requests for ticket's action:\ncreate, update (and update status), collection (fetch all tickets) (de)",
      'latestFailRequestTooltipText': "Table shows date of last fail requests for ticket's action:\ncreate, update (and update status), collection (fetch all tickets) (de)",
      'latestCommentSuccessTooltipText': 'Date of last success request to create comment (de)',
      'latestCommentFailTooltipText': 'Date of last fail request to create comment (de)',
      'latestAttachmentSuccessTooltipText': 'Date of last success request to create attachment (de)',
      'latestAttachmentFailTooltipText': 'Date of last fail request to create attachment (de)',
      'code': 'Code (de)',
      'entity': 'Entity (de)',
      'request': 'request (de)',
      'msgResponse': 'msg response (de)',
      'url': 'url (de)',
      'executed': 'executed at (de)',
      'activeSubscTooltip': 'List of latest emails which were sent to subscribers (de)',
      'activeSubscHeader': 'active subscriptions triggered (de)',
      'user': 'user (de)',
      'status': 'status (de)',
      'ticket': 'id (de)',
      'createdClosedChart': 'created/closed tickets (de)',
      'responseCodesChart': 'HTTP response codes (de)',
      'adminRole': 'Admin (de)',
      'role': 'Role (de)',
      'adminRoRole': 'Admin Read-Only (de)',
      'impersonate': 'Impersonate (de)',
    },
    'ticketsPage': {
      'breadcrumbTicketingSystem': 'Ticketing System (de)',
      'removeTicketsTitle': 'Remove Tickets (de)',
      'removeTicketTitle': 'Remove Ticket (de)',
      'removeTicketsMessage_one': 'Please confirm that you want to remove {{count}} ticket: {{numbers}} (de)',
      'removeTicketsMessage_other': 'Please confirm that you want to remove {{count}} tickets: {{numbers}} (de)',
      'statusesFilterPlaceholder': 'All Statuses (de)',
      'searchPlaceholder': 'Search {{tsName}} tickets... (de)',
      'searchPlaceholderNew': 'search tickets (de)',
      'bulkRemoveLink': 'Bulk remove (de)',
      'removeTicketsLink': 'Remove selected tickets (de)',
      'reloadTicketsLink': 'Reload tickets (de)',
      'status': 'Status (de)',
      'ticket': 'Ticket (de)',
      'ticketsFound': '{{ticketsCount}} tickets found by: (de)',
      'ticketsCount_one': '{{count}} ticket (de)',
      'ticketsCount_other': '{{count}} tickets (de)',
      'sortedByPlaceholder': 'Choose Sorting Field (de)',
      'resetSortingTooltip': 'Reset to Default (de)',
      'sortDirectionTooltip': 'Reverse Sort Direction (de)',
      'sortRelayTicketIdLabel': 'Relay Ticket Id (de)',
      'clearFiltersLink': 'Clear All Filters (de)',
      'tableHeaderId': 'Ticket ID (de)',
      'tableHeaderTitle': 'Title (de)',
      'tooltipMultiUserFilter': 'Multi-user filter (de)',
      'tooltipAdminOnlyFilter': 'Admin-only filter (de)',
      'tooltipPrivateFilter': 'Private filter (de)',
      'filters': 'Filters (de)',
      'removeFilterTitle': 'Remove Filter (de)',
      'removeFilterMessage': 'Are you sure you want to remove  \'{{ filterName }}\' filter? (de)',
      'subscribeToNewTickets': 'Subscribe to new tickets (de)',
      'unSubscribeToNewTickets': 'Unsubscribe from new tickets (de)',
      'subscribeToTicketsView': 'Subscribe to receive notifications about new tickets (de)',
      'unSubscribeToTicketsView': 'Unsubscribe from tickets view (de)',
      'subscribeToTicketsViewTitle': 'Subscribe to Tickets View (de)',
      'subscribeToTicketsViewName': 'View Name (de)',
      'subscribeToTicketsViewFilters': 'Filters (de)',
      'subscribeToTicketsViewStatuses': 'Statuses (de)',
      'subscribeToTicketsViewSearch': 'Search (de)',
      'subscribeToTicketsViewAllTickets': 'All Tickets (de)',
      'subscribeToTicketsViewGroupName': 'Tickets View (de)',
      'manageSubscriptions': 'Manage Subscriptions (de)',
      'tooltipChildTickets_one': 'This ticket contains {{childTicketsIds}} child (de)',
      'tooltipChildTickets_other': 'This ticket contains {{childTicketsIds}} children (de)',
      'tooltipChildTicketsMore': ' and {{count}} more (de)',
      'attachmentsCount_one': '{{count}} attachment (de)',
      'attachmentsCount_other': '{{count}} attachments (de)',
      'commentsCount_one': '{{count}} comment (de)',
      'commentsCount_other': '{{count}} comments (de)',
      'emptyFiltersText': 'No active filters available (de)',
      'createFilterTooltip': 'Create Filter (de)',
      'editFilterTooltip': 'Edit Filter (de)',
      'removeFilterTooltip': 'Remove Filter',
      'filterPanelTitle': 'Tickets View (de)',
      'filterPanelTitleTooltip': 'Click to open Tickets View filter sidebar (de)',
      'filterPanelFiltersTooltip': 'Active Custom Filters (de)',
      'filterPanelClearFiltersTooltip': 'Clear Custom Filters (de)',
      'filterPanelClearStatusesTooltip': 'Clear Status Filters (de)',
      'filterPanelSearchTooltip': 'Click to Search (de)',
      'filterPanelClearSortingTooltip': 'Clear Sorting (de)',
      'filtersStatusSectionTitle': 'Statuses (de)',
      'filterForm': {
        'title': 'Filter Settings (de)',
        'generalInformation': 'General Information (de)',
        'conditions': 'Conditions (de)',
        'saveFilter': 'Save Filter (de)',
        'deleteFilter': 'Delete Filter (de)',
        'fieldLabelName': 'Name (de)',
        'fieldLabelVisibility': 'Visibility (de)',
        'visibilityPrivate': 'Private (de)',
        'visibilityAdmins': 'Admins (de)',
        'visibilityAllUsers': 'All Users (de)',
        'providerTicketBoards': 'Ticket Boards (de)',
        'providerTicketBoardsPlaceholder': 'Ticket Boards Visibility (de)',
        'advancedMode': 'Advanced mode (de)',
        'addNewCondition': 'Add New Condition (de)',
        'advancedTooltip':
          'Operators: LIKE, NOT_LIKE, EQUAL, NOT_EQUAL, IN, NOT_IN, EMPTY, NOT_EMPTY\n' +
          'Keywords: AND, OR\n\n' +
          'Example:\n' +
          'title LIKE "test" OR severity IN 5,4,3  (de)',
        'resultExpression': 'Result Expression (de)',
        'resultExpressionText': 'Show when {{- query}} (de)',
        'table': {
          'field': 'field (de)',
          'operator': 'operator (de)',
          'value': 'value (de)',
        },
        'allFieldsLabel': 'Ticket Fields (de)',
        'dynamicFieldsLabel': 'Dynamic Options (de)',
        'selectFieldPlaceholder': 'select field (de)',
        'selectOperatorPlaceholder': 'select operator (de)',
        'selectValuePlaceholder': 'select value (de)',
        'optionLabels': {
          'is_me': 'Is Me (de)',
          'my_company': 'My Company (de)',
        },
        'removeConditionTooltip': 'Remove Condition (de)',
      },
    },
    'ticketFilterForm': {
      'updateFilter': 'Update Filter (de)',
      'createNewFilter': 'Create New Filter (de)',
      'validateMsgNameRequired': 'Name is required (de)',
      'validateMsgNameExists': 'This name already exists (de)',
      'validateMsgQueryReuired': 'Query is required (de)',
      'validateMsgConditionsRequired': 'Conditions are required (de)',
      'validateMsgConditionsEmpty': 'Condition value should not be empty (de)',
      'conditionsTip':
        'Operators: LIKE, NOT_LIKE, EQUAL, NOT_EQUAL, IN, NOT_IN, EMPTY, NOT_EMPTY\n' +
        'Keywords: AND, OR\n\n' +
        'Example:\n' +
        'title LIKE "test" OR severity IN 5,4,3 (de)',
      'name': 'NAME (de)',
      'namePlaceholder': 'Filter name... (de)',
      'conditions': 'CONDITIONS (de)',
      'advanced': 'Advanced (de)',
      'multiUser': 'Multi-user enabled (de)',
      'showWhenCondition': 'Show when {{- condition}} (de)',
      'addQuery': 'Add Query Language Code (de)',
      'queryPlaceholder': 'Type the query (de)',
      'saveFilter': 'Save Filter (de)',
      'allFieldsLabel': 'Ticket Fields (de)',
      'dynamicFieldsLabel': 'Dynamic Options (de)',
      'isMe': 'Is Me (de)',
      'myCompany': 'My Company (de)',
    },
    'ticketPage': {
      'tableNoData': 'no data (de)',
      'cloneTicketLink': 'Clone ticket (de)',
      'createTicketLink': 'Create ticket (de)',
      'deleteTicketLink': 'Remove ticket (de)',
      'editModeLink': 'Edit Details (de)',
      'refetchTicketLink': 'Reload ticket (de)',
      'requestTicketLink': 'Show ticket requests (de)',
      'addChildTicketsLink': 'Add tickets (de)',
      'moveTicketLink': 'Move ticket (de)',
      'removeTicketTitle': 'Remove Ticket (de)',
      'removeTicketMessage': 'Please confirm that you want to remove ticket: {{number}} (de)',
      'webhookTicketLink': 'Show webhook events (de)',
      'unsubscribeLink': 'Unsubscribe (de)',
      'subscribeLink': 'Subscribe (de)',
      'subscribeLinkHint': 'You are not able to subscribe, <1>please update your email!</1> (de)',
      'commentsAll': 'All (de)',
      'commentsOnly': 'only (de)',
      'comments': 'Comments (de)',
      'commentNew': 'New Comment (de)',
      'commentsNo': 'No comments (de)',
      'commentsValidateBody': 'Comment body is required (de)',
      'commentAbsoluteDate': '{{author}} commented at {{date}} (de)',
      'commentedAt': 'commented at {{date}} (de)',
      'attachments': 'Attachments (de)',
      'attachmentAdd': 'Add Attachment (de)',
      'attachmentTooBig': 'Attachment file is too big (de)',
      'attachmentInvalidType': 'Attachment file is invalid: {{extension}} ({{contentType}}) (de)',
      'attachmentsNo': 'No attachments (de)',
      'attachmentsHeaderId': 'ID (de)',
      'attachmentsHeaderFilename': 'Filename (de)',
      'attachmentsHeaderOwner': 'Owner (de)',
      'attachmentsHeaderCreated': 'Created (de)',
      'attachmentsHeaderSize': 'Size (de)',
      'sidebarDetails': 'DETAILS (de)',
      'sidebarSectionTicketingSystem': 'TICKETING SYSTEM (de)',
      'sidebarSectionTicketId': 'Ticket ID (de)',
      'sidebarSectionRelayId': 'Relay Ticket ID (de)',
      'sidebarSectionType': 'Type (de)',
      'sidebarSectionChildren': {
        'title': 'Children (de)',
        'columns': {
          'id': 'Ticket ID (de)',
          'title': 'Title (de)',
        },
      },
      'sidebarSectionParent': 'Parent (de)',
      'hideReadOnlyFields': 'Hide Read-Only Fields (de)',
      'filteredBy': 'Filtered By (de)',
      'attachmentsFilter': {
        'partnersFilterPlaceholder': 'All Partners (de)',
        'extensionsFilterPlaceholder': 'All Types (de)',
        'searchPlaceholder': 'search attachments (de)',
        'filterPanelSearchTooltip': 'Click to Search (de)',
        'filterPanelClearSortingTooltip': 'Clear Sorting (de)',
        'sortFieldLabels': {
          'external_created_at': 'CREATED DATE (de)',
          'type': 'TYPE (de)',
          'size': 'SIZE (de)',
          'filename': 'FILE NAME (de)',
        },
      },
      'commentsFilter': {
        'partnersFilterPlaceholder': 'All Partners (de)',
        'authorsFilterPlaceholder': 'All Authors (de)',
        'searchPlaceholder': 'search comments (de)',
        'filterPanelSearchTooltip': 'Click to Search (de)',
        'filterPanelClearSortingTooltip': 'Clear Sorting (de)',
        'sortFieldLabel': 'CREATED DATE (de)',
      },
      'childrenSection': {
        'title': 'Children (de)',
      },
      'addTicketsForm': {
        'title': 'Add Tickets (de)',
        'ticketList': 'Ticket List (de)',
        'placeholder': 'Enter ticket ID or title (de)',
      },
      'moveTicketForm': {
        'title': 'Move Ticket (de)',
        'parentTicket': 'Parent (de)',
        'placeholder': 'Enter ticket ID or title (de)',
      },
    },
    'dropzoneFileInput': {
      'placeholder': 'Open or drop file here (de)',
      'maxSizeInfo': 'Max upload size: {{maxSizeText}} (de)',
    },
    'fileProgressbar': {
      'progressText': '{{currentBytesText}} of {{totalBytesText}} (de)',
    },
    'exportFileProgressBar': {
      'progressText': '{{currentPercent}}% of CSV file generated (de)',
    },
    'sidebar': {
      'title': 'Details (de)',
      'statusSection': 'STATUS (de)',
      'userSection': 'CREATED BY USER (de)',
      'noData': 'no data (de)',
      'sidebarSectionsBySchema': {
        'sectionStatusCollectionLinkTooltip': 'Open Status Collection (de)',
        'sectionSharedMapLinkTooltip': 'Open Shared Fields Map (de)',
        'sectionMimeTypeCollectionLinkTooltip': 'Open Mime Type Collection (de)',
        'sectionTicketProviderLinkTooltip': 'Open Ticket Provider (de)',
        'sectionProviderCredentialLinkTooltip': 'Open Provider Credential (de)',
      },
    },
    'ticketEditPage': {
      'pageHeader': 'Edit {{ticketName}} in {{tsName}} (de)',
      'fields': 'Fields (de)',
    },
    'ticketClonePage': {
      'pageHeader': 'Clone Ticket in {{tsName}} (de)',
    },
    'ticketCreatePage': {
      'pageHeader': 'Create Ticket in {{tsName}} (de)',
    },
    'ticketRequestsPage': {
      'pageHeader': 'Requests for {{ticketName}} in {{tsName}} (de)',
    },
    'ticketForm': {
      'buttonCloneTicket': 'Clone Ticket (de)',
      'buttonCreateTicket': 'Create Ticket (de)',
      'inheritedFromParent': 'Inherited from parent (de)',
    },
    'tableFormFieldsBuilder': {
      'creatableArrayField': {
        'text': 'or add via CSV/XLS file (de)',
        'tooltip': 'Open CSV/XLS file (de)',
        'optionsEmpty': 'Empty (de)',
        'optionsAdd': 'Add (de)',
        'itemsMax_one': 'maximum {{count}} item (de)',
        'itemsMax_other': 'maximum {{count}} items (de)',
        'itemsLeft_one': '{{count}} item left (de)',
        'itemsLeft_other': '{{count}} items left (de)',
        'itemsOver_one': '{{count}} item over (de)',
        'itemsOver_other': '{{count}} items over (de)',
        'placeholderAddItems': 'Elemente hinzufügen...',
      },
      'editableArrayField': {
        'tooltipAdd': 'Add New Item (de)',
        'tooltipRemove': 'Remove Item (de)',
        'addButtonLabel': 'Add Item (de)',
      },
    },
    'appRequestsPage': {
      'header': 'Requests (de)',
      'tableHeaderRequest': 'Request (de)',
      'tableHeaderPartner': 'Partner (de)',
      'tableHeaderOrigin': 'Origin (de)',
      'tableHeaderMethod': 'Method (de)',
      'tableHeaderExecutedAt': 'Executed At (de)',
      'tableHeaderCode': 'Code (de)',
      'tableHeaderResponseTime': 'Response Time (de)',
      'sidebarDetails': 'REQUEST DETAILS (de)',
      'sidebarSectionRequestId': 'Request ID (de)',
      'sidebarSectionCorrelationId': 'Correlation ID (de)',
      'sidebarSectionTicketIds': 'Ticket IDs (de)',
      'sidebarSectionTicketProvider': 'Ticket Provider (de)',
      'sidebarSectionTicketProviderId': 'Id (de)',
      'sidebarSectionTicketProviderName': 'Name (de)',
      'sidebarSectionTs': 'Ticketing System (de)',
      'sidebarSectionTsId': 'ID (de)',
      'sidebarSectionTsName': 'Name (de)',
      'sidebarSectionUrl': 'URL (de)',
      'sidebarSectionRespondedAt': 'Responded at (de)',
      'sidebarSectionRespPayload': 'Response Payload (de)',
      'sidebarSectionAuthToken': 'Auth Token (de)',
      'sidebarSectionReqPayload': 'Request Payload (de)',
      'sidebarSectionReqPayloadSize': 'Request Payload Size (de)',
      'sidebarSectionServerName': 'Server Name (de)',
      'sidebarSectionReleaseVersion': 'Release Version (de)',
      'sidebarSectionSourceIp': 'Source IP (de)',
      'sidebarSectionClientId': 'Client ID (de)',
      'sidebarSectionExternalRequestId': 'External Request ID (de)',
      'sidebarSectionWebhookEventId': 'Webhook Event ID (de)',
      'sidebarSectionWebhookExternalEventId': 'Webhook External Event ID (de)',
      'filtersSidebarTitle': 'Filters (de)',
      'clearFiltersLink': 'Clear All Filters (de)',
      'requestsFound_one': '{{count}} request found (de)',
      'requestsFound_other': '{{count}} requests found (de)',
      'traceTooltip': 'Find telemetry trace (de)',
      'copyTooltip': 'Copy Request Details (de)',
    },
    'searchBy': {
      'title': 'Search by (de)',
      'placeholder': 'search (de)',
    },
    'subscriptionsPage': {
      'header': 'Subscriptions (de)',
      'tableHeaderId': 'Ticket ID (de)',
      'tableHeaderStatus': 'Status (de)',
      'tableHeaderTitle': 'Title (de)',
      'tableHeaderUpdated': 'Ticket Updated (de)',
      'inactiveTooltip': 'Ticketing System for this ticket is inactive (de)',
      'unsubscribeTooltip': 'Unsubscribe (de)',
      'subscriptionTypeTickets': 'Tickets (de)',
      'subscriptionTypeViews': 'Views (de)',
      'subscriptionName': 'Name (de)',
      'subscriptionCreatedAt': 'Created At (de)',
      'subscriptionFilteredBy': 'Filtered by (de)',
      'subscriptionsFound': '{{subscriptionsCount}} subscriptions found by (de):',
      'filterTsLabel': 'All Ticketing Systems (de)',
      'subscribeToAllTickets': 'All Tickets (de)',
      'subscribeToStatus': 'Statuses (de)',
      'subscribeToFilter': 'Filters (de)',
      'subscribeToSearch': 'Search (de)',
      'clearFiltersLink': 'Clear All Filters (de)',
      'filterPanelClearSortingTooltip': 'Clear Sorting (de)',
      'subscriptionGoToViews': 'Open Tickets View (de)',
      'FiltersText': 'Filters (de)',
      'SearchText': 'Search (de)',
      'providerTicketBoardText': 'Board (de)',
      'subscriptionsCount_one': '{{count}} subscription (de)',
      'subscriptionsCount_other': '{{count}} subscriptions (de)',
    },
    'releaseNotesPage': {
      'header': 'Release Notes (de)',
      'headerAdd': 'Add New Release (de)',
      'headerEdit': 'Edit {{releaseName}} Release (de)',
      'addRelease': 'Add New Release (de)',
      'subscribeRelease': 'Subscribe to Release Notes (de)',
      'unsubscribeRelease': 'Unsubscribe from Release Notes (de)',
      'editRelease': 'Edit Release (de)',
      'sidebarHeader': 'Releases Archive (de)',
      'publishedTooltip': 'Published Release (de)',
      'unpublishedTooltip': 'Unpublished Release (de)',
      'publishedBadge': 'published (de)',
      'unpublishedBadge': 'unpublished (de)',
      'releaseEmpty': 'Release Notes list is empty (de)',
      'removeReleaseTitle': 'Remove Release Note (de)',
      'removeReleaseMessage': 'Are you sure you want to remove the release note? (de)',
      'editConfirmTitle': 'Save Changes? (de)',
      'editConfirmMessage': 'Please confirm your changes. (de)',
      'formUpdateRelease': 'Update Release (de)',
      'formRemoveRelease': 'Remove Release (de)',
      'formVersion': 'VERSION (de)',
      'formVersionPlaceholder': 'type here (de)',
      'formDate': 'DATE (de)',
      'formDatePlaceholder': 'please select date & time (de)',
      'formPublished': 'PUBLISHED (de)',
      'formDescription': 'DESCRIPTION (de)',
      'formDescriptionPlaceholder': 'add description (de)',
      'formDescriptionTooltip':
        'Please use next format for release notes:\n\n' +
        '## Title Text\n' +
        '### Section 1\n' +
        '- Item 1\n' +
        '- Item 2\n' +
        '- ...\n' +
        '- Item N\n' +
        '### Section 2\n' +
        '- Item 1\n' +
        '- Item 2\n' +
        '- ...\n' +
        '- Item N\n' +
        '...\n' +
        '### Section N\n' +
        '- Item 1\n' +
        '- Item 2\n' +
        '- ...\n' +
        '- Item N\n' +
        '## Footer Text (de)',
    },
    'datetimeInput': {
      'placeholderDate': 'Please select Date (de)',
      'placeholderDateTime': 'Please select Date & Time (de)',
      'timeLabel': 'TIME (de)',
      'am': 'am (de)',
      'pm': 'pm (de)',
      'hours': 'HOURS (de)',
      'minutes': 'MINUTE (de)',
      'seconds': 'SECONDS (de)',
    },
    'sentEmailsPage': {
      'title': 'Sent Emails (de)',
      'filterPanelTitle': 'Filters (de)',
      'filterPanelTitleTooltip': 'Click to open filters sidebar (de)',
      'clearFilterTooltip': 'Clear {{filterName}} filter (de)',
      'clearAllFiltersTooltip': 'Clear all filters (de)',
      'filterPanelFiltersTooltip': 'Active filters (de)',
      'emailsCount': '{{count}} emails (de)',
      'filters': {
        'recipient': 'Recipient (de)',
        'ticketNumber': 'Ticket Number (de)',
        'subject': 'Subject (de)',
        'partner': 'Partner (de)',
        'partners': 'Partners (de)',
        'ticketProvider': 'Ticket Provider (de)',
        'actionType': 'Action Type (de)',
        'code': 'Code (de)',
        'codes': 'Codes (de)',
        'state': 'State (de)',
        'status': 'Status (de)',
      },
      'table': {
        'headerPartner': 'Partner (de)',
        'headerSmtpCode': 'SMTP-Code',
        'headerSubject': 'Thema',
        'headerRecipient': 'Empfänger',
        'headerSentAt': 'Gesendet an',
        'actionResendToMe': 'Nochmals an mich senden',
        'actionResendToMeError': 'Nochmals an mich senden (Scheitern)',
        'headerType': 'Action Type (de)',
      },
      'rightSideBar': {
        'title': 'E-MAIL-DETAILS',
        'sectionSubject': 'Thema',
        'sectionRecipient': 'Empfänger',
        'sectionSmtpRespMsg': 'SMTP-Antwortnachricht',
        'sectionTicketNumber': 'Ticketnummer',
        'sectionTicketingSystem': 'Ticketsystem',
        'sectionState': 'State (de)',
      },
    },
    'columnsPage': {
      'pageHeader': 'Manage Columns for (de)',
      'addColumn': 'Add Column (de)',
      'addNewColumn': 'Add New Column (de)',
      'formFieldName': 'Partner Name (de)',
      'formFieldColId': 'External Name (de)',
      'removeColumn': 'Remove Column (de)',
      'removeColumnMessage': 'Are you sure you want to remove \'{{ columnName }}\' column? (de)',
      'restoreSharedColumn': 'Restore Shared Column (de)',
      'restoreSharedColumnMessage': 'Are you sure you want to restore \'{{ columnName }}\' shared column? (de)',
      'restoreTooltip': 'Restore Shared (de)',
      'removeTooltip': 'Remove (de)',
      'sharedTooltip': 'Shared (de)',
      'customizedTooltip': 'Customized (de)',
      'compareTooltip': 'Compare field map (de)',
      'loadingMatches': 'Loading ...(de)',
      'noMatches': 'No matches (de)',
      'tableHeaderPartnerColumnName': 'partner column name (de)',
      'tableHeaderExternalColumnName': 'external column name (de)',
      'tableHeaderVisible': 'visible (de)',
      'tableHeaderFormVisible': 'visible in form (de)',
      'tableHeaderViewVisible': 'visible in view (de)',
      'tableHeaderFormCreatable': 'creatable (de)',
      'tableHeaderPreview': 'preview (de)',
      'tableHeaderCloned': 'cloned (de)',
      'tableHeaderCloneable': 'cloneable (de)',
      'tableHeaderRequired': 'required (de)',
      'tableHeaderFilterable': 'filterable (de)',
      'tableHeaderFieldType': 'field type (de)',
      'tableHeaderCommentRequired': 'Kommentar erforderlich',
      'columnNamePlaceholder': 'Please enter column name (de)',
      'columnExternalColumnIdPlaceholder': 'Please enter external name (de)',
      'rightSideBar': {
        'formConfig': 'Form Config (de)',
        'viewConfig': 'View Config (de)',
        'formConfigTooltip': 'Configure columns on Ticket Create/Edit/Clone pages (de)',
        'viewConfigTooltip': 'Configure columns on Ticket/Tickets View pages (de)',
        'localizedFieldsOnly': 'Localizations fields only (de)',
        'partnerColumnName': 'Partner Column Name (de)',
        'externalColumnName': 'External Column Name (de)',
        'defineAllowed': 'Define Allowed (de)',
        'defineValueMapping': 'Define Value Mapping (de)',
        'defineExternalToPartnerMapping': 'Enable external value mapping (de)',
        'definePartnerToExternalMapping': 'Enable partner value mapping (de)',
        'defineTableTypeConfig': 'Tabellenkonfiguration',
        'tableTypeConfigIsEmpty': 'Tisch ist leer',
        'addTableTypeConfigItem': 'Spalte hinzufügen',
        'editTableTypeConfigItem': 'Spalte bearbeiten',
        'partnerValue': 'partner value (de)',
        'externalValue': 'external value (de)',
        'allowed': 'Allowed (de)',
        'allowedIsEmpty': 'Allowed list is empty (de)',
        'name': 'Name (de)',
        'namePlaceholder': 'Please enter name (de)',
        'value': 'Value (de)',
        'valuePlaceholder': 'Please enter value (de)',
        'default': 'default (de)',
        'tooltip': 'tooltip (de)',
        'placeholder': 'placeholder (de)',
        'visible': 'visible (de)',
        'writeable': 'writeable (de)',
        'creatable': 'creatable (de)',
        'editable': 'editable (de)',
        'setOnce': 'set once (de)',
        'displayInSidebar': 'display in sidebar (de)',
        'showInPreview': 'show in preview (de)',
        'displayInPreview': 'display in preview (de)',
        'cloned': 'cloned (de)',
        'cloneable': 'cloneable (de)',
        'filterable': 'filterable (de)',
        'sortable': 'sortable (de)',
        'hideValueInEmail': 'Hide value in Email (de)',
        'notifyViaEmail': 'Notify via Email (de)',
        'field_type': 'Field Type (de)',
        'main_ui_attr': 'Main UI Attribute (de)',
        'main_external_attr': 'Main External Attribute (de)',
        'nested_field_name': 'Nested Field Name (de)',
        'required': 'required (de)',
        'commentRequired': 'Kommentar erforderlich',
        'tooltipRequired': 'Field can be required if it has default value or it is visible and writeable (de)',
        'tooltipShowInPreview': 'Show this field in the preview section on the Tickets List page (de)',
        'tooltipDisplayInSidebar': 'Show this field in the sidebar section on the Ticket View page (de)',
        'tooltipDisplayInSidebarFormConfig': 'Show this field in the sidebar section on the Ticket Create/Edit/Clone pages (de)',
        'manageAllowed': 'MANAGE FIELD MAPPING (de)',
        'modalHeader': 'Discard Changes (de)',
        'modalText': 'Are you sure you want to discard changes? (de)',
        'modalHeaderRemove': 'Remove {{columnName}} (de)',
        'modalTextRemove': 'Are you sure you want to remove \'{{valueName}}\' {{columnName}}? (de)',
        'tooltipEdit': 'Edit (de)',
        'tooltipRemove': 'Remove (de)',
        'addAllowed': 'Add Allowed Value (de)',
        'editAllowed': 'Edit Allowed Value (de)',
        'changeOrder': 'Change Order (de)',
        'addExternalValueMapping': 'Add New External Value Map (de)',
        'editExternalValueMapping': 'Edit External Value Map (de)',
        'externalValueMappingIsEmpty': 'External value mapping is empty (de)',
        'removeExternalMappingValue': 'Remove External Value Map (de)',
        'removeExternalMappingValueText': 'Are you sure you want to remove \'{{ externalValue }}\' external value map? (de)',
        'addPartnerValueMapping': 'Add New Partner Value Map (de)',
        'editPartnerValueMapping': 'Edit Partner Value Map (de)',
        'partnerValueMappingIsEmpty': 'Partner value mapping is empty (de)',
        'removePartnerMappingValue': 'Remove Partner Value Map (de)',
        'removePartnerMappingValueText': 'Are you sure you want to remove \'{{ partnerValue }}\' partner value map? (de)',
        'externalValueForm': {
          'value': 'value (de)',
          'valuePlaceholder': 'input value (de)',
        },
        'emptyPartnerValue': 'empty (de)',
        'partnerValueForm': {
          'value': 'value (de)',
          'valuePlaceholder': 'input value (de)',
          'default': 'default (de)',
        },
        'arrayCsvLimit': 'Limit of max number of items (de)',
      },
      'settingsModal': {
        'title': 'Column Settings (de)',
      },
    },
    'select': {
      'noOptions': 'no data (de)',
      'placeholder': 'Select ...(de)',
      'loadingMessage': 'loading ...(de)',
    },
    'partnersPage': {
      'pageHeader': 'Partners (de)',
      'addPartner': 'Add Partner (de)',
      'addNewPartner': 'Add New Partner (de)',
      'formFieldName': 'Name (de)',
      'partnerNamePlaceholder': 'Please enter partner name (de)',
      'fieldSsoZone': 'SSO Zone (de)',
      'fieldSsoEnv': 'SSO Environment (de)',
      'ssoZonePlaceholder': 'Please select SSO Zone (de)',
      'ssoEnvPlaceholder': 'Please select SSO Environment (de)',
      'formFieldXerxesPartnerName': 'Xerxes Name (de)',
      'formFieldXerxesPartnerNamePlaceholder': 'Please enter Xerxes partner name (de)',
      'fieldXerxesZone': 'Xerxes Zone (de)',
      'fieldXerxesEnv': 'Xerxes Environment (de)',
      'xerxesZonePlaceholder': 'Please select Xerxes Zone (de)',
      'xerxesEnvPlaceholder': 'Please select Xerxes Environment (de)',
      'formFieldSatPartnerName': 'SAT Name (de)',
      'formFieldSatPartnerNamePlaceholder': 'Please enter SAT partner name (de)',
      'fieldSatZone': 'SAT Zone (de)',
      'satZonePlaceholder': 'Please select SAT Zone (de)',
      'fieldSatEnv': 'SAT Environment (de)',
      'satEnvPlaceholder': 'Please select SAT Environment (de)',
      'removePartnerTitle': 'Remove Partner (de)',
      'removePartnerMessage': 'Are you sure you want to remove \'{{partnerName}}\' partner? (de)',
      'tableHeaderPartnerName': 'partner name (de)',
      'tableHeaderMainPartner': 'main partner (de)',
      'tableHeaderActive': 'active (de)',
      'tableHeaderVisibility': 'visibility (de)',
      'visibilityFull': 'full (de)',
      'visibilityRestricted': 'restricted (de)',
      'tooltipOauthApps': 'Manage Oauth apps (de)',
      'tooltipGenerateOpenApi': 'Generate OpenApi (de)',
      'tooltipTicketingSystems': 'Ticketing Systems (de)',
      'tooltipRemovePartner': 'Remove Partner (de)',
      'rightSideBar': {
        'sectionPartnerName': 'Partner Name (de)',
        'sectionXerxesPartnerName': 'Xerxes Partner Name (de)',
        'sectionActive': 'Active (de)',
        'sectionMainPartner': 'Main Partner (de)',
        'sectionUseMtls': 'Use MTLS authentication (de)',
        'sectionVisibility': 'Visibility (de)',
        'sectionLogo': 'Logo (de)',
        'sectionSystemBranding': {
          'title': 'System Branding (de)',
          'copyrightText': 'Copyright Text (de)',
          'logo': 'Logo (de)',
        },
        'sectionLandingPage': {
          'header': 'Landing Page Content (de)',
          'title': 'Title (de)',
          'titlePlaceholder': 'Please, enter title (de)',
          'text': 'Text (de)',
          'textPlaceholder': 'Please, enter text (de)',
        },
        'sectionManage': 'Manage (de)',
        'visibilityFull': 'Full (de)',
        'visibilityRestricted': 'Restricted (de)',
        'sectionTicketIdName': 'Ticket id field name (de)',
      },
      'settingsModal': {
        'title': 'Partner Settings (de)',
      },
    },
    'iconRecommendation': {
      'recommendations': 'Recommendations (de)',
      'size': 'size (de)',
      'formats': 'formats (de)',
      'uploadLogo': 'Upload Logo (de)',
    },
    'imagePicker': {
      'recommendationsTitle': 'Recommendations (de)',
      'size': 'size (de)',
      'formats': 'formats (de)',
      'uploadLogo': 'Upload Logo (de)',
      'updateLogo': 'Update Logo (de)',
    },
    'statusCollectionsPage': {
      'pageHeader': 'Status Collections (de)',
      'addEntity': 'Add Status Collection (de)',
      'importStatusCollection': 'Import Status Collection (de)',
      'addNewEntity': 'Add New Status Collection (de)',
      'formFieldName': 'Name (de)',
      'statusCollectionNamePlaceholder': 'Please enter Status Collection name (de)',
      'removeStatusCollectionTitle': 'Remove Status Collection (de)',
      'removeStatusCollectionMessage': 'Are you sure you want to remove \'{{statusCollectionName}}\' status collection? (de)',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticketing systems or ticket providers (de)',
      'hintCannotBeRemovedHasStatuses': 'Cannot be removed while it has partner statuses (de)',
      'manageStatuses': 'Manage Partner Statuses (de)',
      'tableHeaderName': 'Status Collection Name (de)',
      'rightSideBar': {
        'title': 'DETAILS (de)',
        'sectionUsedBy': 'Used By (de)',
        'sectionUsedByTicketingSystem': 'Ticketing Systems (de)',
        'sectionUsedByTicketProvider': 'Ticket Providers (de)',
      },
      'settingsModal': {
        'title': 'Status Collection Settings (de)',
      },
    },
    'statusCollectionPage': {
      'pageHeader': 'Partner Statuses for (de)',
      'addEntity': 'Add Partner Status (de)',
      'addNewEntity': 'Add new partner status (de)',
      'tableHeaderPartnerStatus': 'Partner Status (de)',
      'tableHeaderExternalStatuses': 'External Statuses (de)',
      'tableHeaderDefault': 'Default (de)',
      'removePartnerStatusTitle': 'Remove partner status (de)',
      'removePartnerStatusMessage': 'Are you sure you want to remove \'{{ partnerStatusName }}\' partner status? (de)',
      'tooltipRemove': 'Remove (de)',
      'partnerStatusName': 'Name (de)',
      'partnerStatusClosedState': 'Closed State (de)',
      'partnerStatusNamePlaceholder': 'Please enter partner status name (de)',
      'partnerStatusColor': 'Status Color (de)',
      'partnerStatusDefault': 'Default (de)',
      'extFormName': 'Name (de)',
      'extFormNamePlaceholder': 'Please enter name for external status (de)',
      'extFormNotes': 'Notes (de)',
      'extFormNotesPlaceholder': 'Please enter notes for external status (de)',
      'extFormStatusTrans': 'Status Transitions (de)',
      'extFormReadOnly': 'Read Only (de)',
      'manageExternalStatuses': 'Manage External Statuses (de)',
      'externalStatusesTab': 'External Statuses (de)',
      'rightSideBar': {
        'title': 'DETAILS (de)',
      },
      'settingsModal': {
        'title': 'Partner Status Settings (de)',
      },
    },
    'externalStatusesPage': {
      'pageHeader': 'External Statuses for (de)',
      'addEntity': 'Add External Status (de)',
      'addNewEntity': 'Add New External Status (de)',
      'breadcrumbExternalStatuses': 'External Statuses (de)',
      'tableHeaderName': 'Name (de)',
      'tableHeaderNote': 'Note (de)',
      'tableHeaderTransitions': 'Transitions (de)',
      'tableHeaderReadOnly': 'Read Only (de)',
      'removeExternalStatusTitle': 'Remove external status (de)',
      'removeExternalStatusMessage': 'Are you sure you want to remove \'{{ externalStatusName }}\' external status? (de)',
      'tooltipRemove': 'Remove (de)',
      'rightSideBar': {
        'title': 'DETAILS (de)',
      },
      'settingsModal': {
        'title': 'External Status Settings (de)',
      },
    },
    'ticketProvidersPage': {
      'importTicketProvider': 'Import Ticket Provider (de)',
      'pageHeader': 'Ticket Providers (de)',
      'addProvider': 'Add Provider (de)',
      'addNewProvider': 'Add New Ticket Provider (de)',
      'formFieldName': 'Name (de)',
      'formFieldProjectName': 'Project Name (de)',
      'formPlaceholderName': 'Enter Name (de)',
      'formPlaceholderProjectName': 'Enter Project Name (de)',
      'removeProviderTitle': 'Remove Ticket Provider (de)',
      'removeProviderMessage': 'Are you sure you want to remove \'{{ticketProviderName}}\' ticket provider? (de)',
      'cleanupTickets': 'Cleanup tickets (de)',
      'cleanupTicketsMessage': 'Are you sure you want to remove all tickets for selected ticket provider? (de)',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticketing systems (de)',
      'tableHeaderProviderName': 'ticket provider name (de)',
      'tableHeaderProviderType': 'type (de)',
      'tableHeaderProjectName': 'project name (de)',
      'tableHeaderTsCount': 'ticketing systems count (de)',
      'tableHeaderEndpoint': 'endpoint (de)',
      'tableHeaderStatusCollection': 'status collection (de)',
      'tableHeaderSharedMap': 'shared fields map (de)',
      'showQueriesTooltip': 'Show Queries (de)',
      'showProviderTicketBoardsTooltip': 'Show Ticket Boards (de)',
      'rightSideBar': {
        'sectionProviderName': 'Ticket Provider Name (de)',
        'sectionProjectName': 'Project Name (de)',
        'sectionTCEndpoint': 'Endpoint (de)',
        'sectionTPType': 'Type (de)',
        'sectionUrl': 'URL (de)',
        'sectionClientId': 'Client Id (de)',
        'sectionUsername': 'User Name (de)',
        'sectionConnection': 'Connection (de)',
        'sectionAttachments': 'Attachments (de)',
        'sectionComments': 'Comments (de)',
        'sectionCloneTickets': 'Clone tickets (de)',
        'sectionAllowNewTickets': 'Create tickets (de)',
        'sectionStatusCollection': 'Status Collection (de)',
        'sectionStatusCollectionLinkTooltip': 'Open Status Collection (de)',
        'sectionSharedMap': 'Shared Fields Map (de)',
        'sectionSharedMapLinkTooltip': 'Open Shared Fields Map (de)',
        'sectionUsedBy': 'Used By (de)',
        'sectionUsedByTicketingSystem': 'Ticketing Systems (de)',
        'sectionLogo': 'Logo (de)',
        'sectionKinesisEnabled': 'Kinesis (de)',
        'sectionStreamName': 'Stream Name (de)',
        'sectionRegion': 'Region (de)',
        'sectionRole': 'Role (de)',
      },
      'connectionSettingsModal': {
        'title': 'Connection (de)',
        'providerType': 'Provider Type (de)',
        'settings': 'Settings (de)',
      },
      'settingsModal': {
        'title': '{{name}} Provider Settings (de)',
      },
    },
    'queriesPage': {
      'enqueueQuery': 'Perform Query (de)',
      'dryRunQuery': 'Dry Run Query (de)',
      'dryRunEmptyResult': 'Result is empty (de)',
      'dryRunQueryModalTitle': '\'{{queryName}}\' Query Dry Run Result (de)',
      'newPageHeader': 'Manage Queries (de)',
      'breadcrumbs': 'Queries (de)',
      'pageHeader': 'Queries for {{ type }} (de)',
      'addQuery': 'Add Query (de)',
      'addFormTitle': 'Add New Query (de)',
      'addFormQueryName': 'NAME (de)',
      'addFormQueryNamePlaceholder': 'name (de)',
      'addFormQueryBody': 'BODY (de)',
      'addFormQueryBodyPlaceholder': 'description (de)',
      'removeQueryTitle': 'Remove Query (de)',
      'removeQueryMessage': 'Are you sure you want to remove \'{{queryName}}\' query? (de)',
      'tableHeaderQueryName': 'query name (de)',
      'tableHeaderActive': 'active (de)',
      'tableHeaderExecPeriod': 'execution period (de)',
      'useToReloadTickets': 'Use to Reload Tickets (de)',
      'rightSideBar': {
        'sectionProviderName': 'Ticket Provider Name (de)',
        'sectionQueryName': 'Name (de)',
        'sectionQueryBody': 'Body (de)',
        'sectionStartAt': 'Start At (de)',
        'sectionMaxResults': 'Max Results (de)',
        'sectionExecPeriod': 'Execution Period (de)',
        'sectionTicketProvider': 'Ticket Provider (de)',
        'sectionActive': 'Active (de)',
        'offsetTooltipText': 'Time Offset in Minutes (de)',
      },
      'settingsModal': {
        'title': 'Query Settings (de)',
      },
    },
    'providerTicketBoardsPage': {
      'newPageHeader': 'Manage Ticket Boards (de)',
      'breadcrumbs': 'Ticket Boards  (de)',
      'addTicketBoard': 'Add Ticket Board (de)',
      'addFormTitle': 'Add New Ticket Board (de)',
      'addFormTicketBoardName': 'NAME (de)',
      'addFormTicketBoardNamePlaceholder': 'name (de)',
      'addFormTicketBoardQuery': 'QUERY (de)',
      'addFormTicketBoardQueryPlaceholder': 'Query body (de)',
      'removeTicketBoardTitle': 'Remove Ticket Board (de)',
      'removeTicketBoardMessage': 'Are you sure you want to remove \'{{providerTicketBoardName}}\' ticket board? (de)',
      'tableHeaderTicketBoardName': 'Ticket Board Name (de)',
      'tableHeaderActive': 'active (de)',
      'tableHeaderDefault': 'default (de)',
      'tooltipEditTable': 'Edit Table (de)',
      'tooltipEditCsvExportTable': 'Edit CSV Export Table (de)',
      'rightSideBar': {
        'sectionProviderName': 'Ticket Provider Name (de)',
        'sectionTicketBoardName': 'Name (de)',
        'sectionTicketBoardQuery': 'Query (de)',
        'sectionActive': 'Active (de)',
        'sectionDefault': 'Default (de)',
        'sectionUsedBy': 'Used By (de)',
      },
      'settingsModal': {
        'title': 'Ticket Board Settings (de)',
      },
    },
    'csvExportTableEditPage': {
      'pageHeader': 'Edit Ticket CSV Export Table (de)',
    },
    'sharedFieldsMapsPage': {
      'pageHeader': 'Shared Fields Maps (de)',
      'importSharedFieldsMap': 'Import Shared Fields Map (de)',
      'addEntity': 'Add Shared Fields Map (de)',
      'addNewEntity': 'Add New Shared Fields Map (de)',
      'formFieldName': 'Name (de)',
      'sharedFieldsMapNamePlaceholder': 'Please enter Shared Fields Map name (de)',
      'removeEntity': 'Remove Shared Fields Map (de)',
      'removeEntityMessage': 'Are you sure you want to remove \'{{sharedFieldsMapName}}\' shared fields map? (de)',
      'manageColumns': 'Manage Columns (de)',
      'tableHeaderName': 'shared fields map name (de)',
      'rightSideBar': {
        'title': 'DETAILS (de)',
        'sectionSharedFieldsMapName': 'Shared Fields Map Name (de)',
        'sectionUsedBy': 'Used By (de)',
        'sectionUsedByTicketProvider': 'Ticket Provider (de)',
      },
      'settingsModal': {
        'title': 'Shared Fields Maps Settings (de)',
        'sectionUsedByTicketProvider': 'Ticket Providers (de)',
      },
    },
    'auditPage': {
      'actionsTitle': 'ACTIONS (de)',
      'actionCreate': 'Create action (de)',
      'actionUpdate': 'Update action (de)',
      'actionDestroy': 'Destroy action (de)',
      'tableHeader': 'Action (de)',
      'justificationTitle': 'Justification (de)',
      'sideBarTitle': 'CHANGES (de)',
      'actionsType': {
        'allPartnerActions': 'all_partner_actions (de)',
        'userActions': 'user_actions (de)',
        'integrationActions': 'integration_actions (de)',
        'adminActions': 'admin_actions (de)',
      },
      'auditable': {
        'auditableModels': 'Auditable models (de)',
        'ticketingSystemTicket': 'TicketingSystemTicket (de)',
        'providerTicket': 'ProviderTicket (de)',
        'providerComment': 'ProviderComment (de)',
        'providerAttachment': 'ProviderAttachment (de)',
        'subscription': 'Subscription (de)',
        'userFilter': 'UserFilter (de)',
        'provider': 'TicketProvider (de)',
        'partner': 'Partner (de)',
        'ts': 'TicketingSystem (de)',
        'tsColumn': 'BaseColumn (de)',
        'tsQuery': 'TicketingSystemQuery (de)',
        'statusCollection': 'StatusCollection (de)',
        'partnerStatus': 'PartnerStatus (de)',
        'externalStatus': 'ExternalStatus (de)',
        'providerCredential': 'ProviderCredential (de)',
        'attachmentMimeType': 'AttachmentMimeType (de)',
        'mimeTypeCollection': 'MimeTypeCollection (de)',
        'providerTicketBoard': 'ProviderTicketBoard (de)',
      },
    },
    'metaDataPages': {
      'adminSubscriptions': {
        'header': 'Subscriptions (de)',
        'filterBy': 'Filter by (de)',
        'filterPartnerLabel': 'All Partners (de)',
        'filterStatusesLabel': 'All Statuses (de)',
        'table': {
          'ticket': 'Ticket ID (de)',
          'subscribed': 'Subscribed by (de)',
          'userPartner': 'Partner (de)',
          'ticketStatus': 'Ticket Status (de)',
          'title': 'Title (de)',
          'ticketUpdated': 'Ticket Updated (de)',
          'subscriptionCreatedAt': 'Created At (de)',
          'userInfoTooltip': 'Name: {{subscriberName}}\nLogin: {{subscriberLogin}}\nEmail: {{subscriberEmail}} (de)',
        },
      },
      'userFiltersPage': {
        'header': 'User Filters (de)',
        'filterTypesPlaceholder': 'All Types (de)',
        'filterProviderLabel': 'All Providers (de)',
        'showFilter': 'Show Filters (de)',
        'filterPlaceholder': 'Filter name or user (de)',
        'table': {
          'name': 'Name (de)',
          'createdBy': 'Created by (de)',
          'query': 'Query (de)',
          'type': 'Type (de)',
          'partner': 'Partner (de)',
          'ts': 'Ticketing System (de)',
          'provider': 'Ticket Provider (de)',
          'providerTicketBoard': 'Provider Ticket Board (de)',
          'createdAt': 'Created At (de)',
          'userInfoTooltip': 'Name: {{userName}}\nLogin: {{userLogin}}\nEmail: {{userEmail}} (de)',
        },
        'filtersFound': '{{filtersCount}} filters found by: (de)',
      },
      'usersPage': {
        'header': 'Users (de)',
        'table': {
          'login': 'Login (de)',
          'firstName': 'First Name (de)',
          'lastName': 'Last Name (de)',
          'email': 'Email (de)',
          'capability': 'Сapability (de)',
          'partner': 'Partner (de)',
          'lastLogin': 'Last login (de)',
          'alertHeader': 'Remove User (de)',
          'alertText': 'Are you sure you want to remove \'{{ userName }}\' user? (de)',
        },
        'roles': {
          'admin': 'Admin (de)',
          'adminImpersonated': 'Admin Impersonated (de)',
          'adminReadOnly': 'Admin Read Only (de)',
          'adminReadOnlyImpersonated': 'Admin Read Only Impersonated (de)',
          'powerUser': 'Power User (de)',
          'powerUserImpersonated': 'Power User Impersonated (de)',
          'partner': 'Partner (de)',
        },
        'filterPanelTitle': 'Filters (de)',
        'filterPanelTitleTooltip': 'Click to open Filters sidebar (de)',
        'clearAllFiltersTooltip': 'Clear Filters (de)',
        'filterPanelFiltersTooltip': 'Active Filters (de)',
        'usersCount_one': '{{count}} user (de)',
        'usersCount_other': '{{count}} users (de)',
        'clearFilterTooltip': 'Clear "{{filterName}}" Filter (de)',
        'rightSideBar': {
          'header': 'User Details (de)',
          'sectionId': 'Id (de)',
          'sectionFirstName': 'First Name (de)',
          'sectionLastName': 'Last Name (de)',
          'sectionEmail': 'Email (de)',
          'sectionPartner': 'Partner (de)',
          'sectionRole': 'Role (de)',
          'sectionCapability': 'Capability (de)',
          'sectionTimezone': 'Time Zone (de)',
          'sectionLastVisitApiDoc': 'Last Visit of API Doc (de)',
          'sectionFirstLogin': 'First Login (de)',
          'sectionApiDocVisitCount': 'API Doc Visit Count (de)',
          'sectionLoginCount': 'Login Count (de)',
          'autosubscription': 'Autosubscription (de)',
        },
        'filters': {
          'partnerName': 'Partner (de)',
          'login': 'Login (de)',
          'email': 'Email (de)',
          'role': 'Role (de)',
          'capability': 'Сapability (de)',
          'timeZone': 'Time Zone (de)',
          'autosubscription': 'Autosubscription (de)',
          'firstLoginStartDate': 'First Login Start Time (de)',
          'firstLoginEndDate': 'First Login End Time (de)',
          'lastLoginStartDate': 'Last Login Start Time (de)',
          'lastLoginEndDate': 'Last Login End Time (de)',
          'visitApiStartDate': 'Last Visit of API Doc Start Time (de)',
          'visitApiEndDate': 'Last Visit of API Doc End Time (de)',
        },
      },
    },
    'partnerTicketingSystemsPage': {
      'pageHeader': 'Manage Ticketing Systems for {{partnerName}} (de)',
      'addTs': 'Add Ticketing System (de)',
      'addTsNew': 'Add New Ticketing System (de)',
      'importTs': 'Import Ticketing System (de)',
      'formFieldName': 'Name (de)',
      'tsNamePlaceholder': 'Please enter Ticketing System name (de)',
      'table': {
        'displayId': 'Display ID (de)',
        'removeTitle': 'Remove Ticketing System (de)',
        'removeText': 'Are you sure you want to remove \'{{ticketingSystemName}}\' ticketing system? (de)',
        'name': 'Name (de)',
        'tp': 'Ticket Provider (de)',
        'uiAccess': 'ui access (de)',
        'apiAccess': 'api access (de)',
        'allowNewTickets': 'create tickets  (de)',
        'attachments': 'attachments (de)',
        'comments': 'comments (de)',
        'manageColumns': 'Manage Columns (de)',
      },
      'rightSideBar': {
        'displayId': 'Display ID (de)',
        'tsName': 'Ticketing System Name (de)',
        'tp': 'Ticket Provider (de)',
        'tpLinkTooltip': 'Open Ticket Provider (de)',
        'statusCollection': 'Status Collection (de)',
        'statusCollectionLinkTooltip': 'Open Status Collection (de)',
        'uiAccess': 'UI Access (de)',
        'apiAccess': 'API Access (de)',
        'allowNewTickets': 'Create tickets (de)',
        'attachments': 'Attachments (de)',
        'comments': 'Comments (de)',
        'emailSettings': 'Email Settings (de)',
        'emailSettingsComment': 'Display Comment Details (de)',
        'emailSettingsAttachment': 'Display Attachment Details (de)',
        'publishInternalFields': 'Publish Internal Fields (de)',
        'usePtgwTimestamp': 'Use internal Relay timestamp for ticket filtering by default (de)',
        'ticketBonding': 'Ticket Bonding (de)',
        'manageUiAccess': 'UI Access management (de)',
        'addUiAccess': 'Add Role (de)',
        'editUiAccess': 'Edit Role (de)',
        'uiAccessIsEmpty': 'UI Access not configured (de)',
        'uiAccessRole': 'role (de)',
        'uiAccessRolePlaceholder': 'Please, enter user role (de)',
        'uiAccessAccessPlaceholder': 'Please, select UI Access (de)',
        'uiAccessAccess': 'Ui access (de)',
        'uiAccessRemoveTitle': 'Remove Role (de)',
        'uiAccessRemoveAlert': 'Are you sure you want to remove \'{{ roleName }}\' Role? (de)',
        'excludedPartnerStatuses': 'Excluded Partner Statuses (de)',
        'excludedPartnerStatusesTooltip': 'Unbonded tickets with selected partners statuses will be not displayed (de)',
      },
      'settingsModal': {
        'title': 'Ticketing System Settings (de)',
      },
    },
    'feedbackPage': {
      'pageHeader': 'Feedback (de)',
      'feedbacksFound': '{{feedbacksCount}} feedback found by: (de)',
      'filter': {
        'statusFilterPlaceholder': 'All Statuses (de)',
        'partnerFilterPlaceholder': 'All Partners (de)',
        'searchPlaceholder': 'search feedback... (de)',
      },
      'table': {
        'status': 'status (de)',
        'reference': 'reference (de)',
      },
      'sidebar': {
        'experience': 'experience (de)',
        'reference': 'reference (de)',
        'status': 'status (de)',
        'statusRejected': 'Rejected (de)',
        'statusApproved': 'Approved (de)',
        'notes': 'Notes (de)',
        'originLocation': 'Herkunftsort',
      },
    },
    'feedbackSidebarForm': {
      'title': 'Send us your feedback! (de)',
      'subtitle1': 'Do you have a suggestion or have found an issue? (de)',
      'subtitle2': 'Let the Relay team know. (de)',
      'experienceSectionTitle': 'How was your experience? (de)',
      'descSectionTitle': 'Describe your experience (de)',
      'buttonLabel': 'Send Feedback (de)',
      'menuButtonTooltip': 'Send Feedback (de)',
    },
    'signInPanel': {
      'title': 'Your Auth Provider (de)',
      'signIn': 'Sign In (de)',
    },
    'sandboxSignInPanel': {
      'name': 'Input Your Name (de)',
      'provider': 'Select Provider (de)',
      'role': 'Select Role (de)',
    },
    'ticketsSearchResultsPage': {
      'pageHeader': 'Search Results (de)',
      'moreLink': 'Show More (de)',
      'ticketsFound': '{{ticketsCount}} tickets found (de)',
    },
    'ticketProviderTicketsSearchResultsPage': {
      'pageHeader': 'Search Results (de)',
      'moreLink': 'Show More (de)',
      'ticketsFound': '{{ticketsCount}} tickets found (de)',
    },
    'welcomePage': {
      'greeting': 'Welcome (de)',
      'selectTS': 'Select a Ticketing System.... (de)',
    },
    'ticketTableEditPage': {
      'pageHeader': 'Edit Ticket Table (de)',
      'addColumns': 'Add Column(s) (de)',
      'editColumnList': 'Edit Column List (de)',
      'addNewColumns': 'Add New Column(s) (de)',
      'columns': 'Column(s) (de)',
      'columnName': 'Column Name (de)',
      'tooltipRemoveColumn': 'Remove Column (de)',
    },
    'ticketProviderTicketPage': {
      'tableNoData': 'no data (de)',
      'deleteTicketLink': 'Remove ticket (de)',
      'reloadTicketLink': 'Reload ticket (de)',
      'requestTicketLink': 'Show ticket requests (de)',
      'removeTicketTitle': 'Remove Ticket (de)',
      'removeTicketMessage': 'Please confirm that you want to remove ticket: {{number}} (de)',
      'commentsAll': 'All (de)',
      'commentsOnly': 'only (de)',
      'comments': 'Comments (de)',
      'commentsNo': 'No comments (de)',
      'attachments': 'Attachments (de)',
      'attachmentsNo': 'No attachments (de)',
      'attachmentsHeaderId': 'ID (de)',
      'attachmentsHeaderFilename': 'Filename (de)',
      'attachmentsHeaderOwner': 'Owner (de)',
      'attachmentsHeaderCreated': 'Created (de)',
      'attachmentsHeaderSize': 'Size (de)',
      'sidebarDetails': 'DETAILS (de)',
      'sidebarSectionTicketProvider': 'TICKET PROVIDER (de)',
      'sidebarSectionRelayId': 'Relay Ticket ID (de)',
      'sidebarSectionType': 'Type (de)',
      'sidebarSectionChildren': {
        'title': 'Children (de)',
        'columns': {
          'id': 'Ticket ID (de)',
          'title': 'Title (de)',
        },
      },
      'filteredBy': 'Filtered By (de)',
      'attachmentsFilter': {
        'partnersFilterPlaceholder': 'All Partners (de)',
        'extensionsFilterPlaceholder': 'All Types (de)',
        'searchPlaceholder': 'search attachments (de)',
        'filterPanelSearchTooltip': 'Click to Search (de)',
        'filterPanelClearSortingTooltip': 'Clear Sorting (de)',
        'sortFieldLabels': {
          'external_created_at': 'CREATED DATE (de)',
          'type': 'TYPE (de)',
          'size': 'SIZE (de)',
          'filename': 'FILE NAME (de)',
        },
      },
      'commentsFilter': {
        'partnersFilterPlaceholder': 'All Partners (de)',
        'authorsFilterPlaceholder': 'All Authors (de)',
        'searchPlaceholder': 'search comments (de)',
        'filterPanelSearchTooltip': 'Click to Search (de)',
        'filterPanelClearSortingTooltip': 'Clear Sorting (de)',
        'sortFieldLabel': 'CREATED DATE (de)',
      },
      'childrenSection': {
        'title': 'Children (de)',
      },
    },
    'ticketProviderTicketsPage': {
      'removeTicketsTitle': 'Remove Tickets (de)',
      'removeTicketsMessage_one': 'Please confirm that you want to remove {{count}} ticket: {{numbers}} (de)',
      'removeTicketsMessage_other': 'Please confirm that you want to remove {{count}} tickets: {{numbers}} (de)',
      'statusesFilterPlaceholder': 'All Statuses (de)',
      'searchPlaceholder': 'Search {{ticketProviderName}} tickets... (de)',
      'searchPlaceholderNew': 'search tickets (de)',
      'bulkRemoveLink': 'Bulk remove (de)',
      'removeTicketsLink': 'Remove selected tickets (de)',
      'reloadTicketsLink': 'Reload tickets (de)',
      'ticketsFound': '{{ticketsCount}} tickets found by: (de)',
      'ticketsCount_one': '{{count}} ticket (de)',
      'ticketsCount_other': '{{count}} tickets (de)',
      'sortedByPlaceholder': 'Choose Sorting Field (de)',
      'resetSortingTooltip': 'Reset to Default (de)',
      'sortDirectionTooltip': 'Reverse Sort Direction (de)',
      'sortRelayTicketIdLabel': 'Relay Ticket Id (de)',
      'clearFiltersLink': 'Clear All Filters (de)',
      'tableHeaderId': 'Ticket ID (de)',
      'tableHeaderPartnerId': 'Partner ID (de)',
      'tableHeaderOwner': 'Owner (de)',
      'tableHeaderStatus': 'Status (de)',
      'tableHeaderTitle': 'Title (de)',
      'tooltipMultiUserFilter': 'Multi-user filter (de)',
      'tooltipAdminOnlyFilter': 'Admin-only filter (de)',
      'tooltipPrivateFilter': 'Private filter (de)',
      'filters': 'Filters (de)',
      'removeFilterTitle': 'Remove Filter (de)',
      'removeFilterMessage': 'Are you sure you want to remove \'{{ filterName }}\' filter? (de)',
      'tooltipChildTickets_one': 'This ticket contains {{childTicketsIds}} child (de)',
      'tooltipChildTickets_other': 'This ticket contains {{childTicketsIds}} children (de)',
      'tooltipChildTicketsMore': ' and {{count}} more (de)',
      'attachmentsCount_one': '{{count}} attachment (de)',
      'attachmentsCount_other': '{{count}} attachments (de)',
      'commentsCount_one': '{{count}} comment (de)',
      'commentsCount_other': '{{count}} comments (de)',
      'emptyFiltersText': 'No active filters available (de)',
      'createFilterTooltip': 'Create Filter (de)',
      'editFilterTooltip': 'Edit Filter (de)',
      'removeFilterTooltip': 'Remove Filter (de)',
      'filterPanelTitle': 'Tickets View (de)',
      'filterPanelTitleTooltip': 'Click to open Tickets View filter sidebar (de)',
      'filterPanelFiltersTooltip': 'Active Custom Filters (de)',
      'filterPanelClearFiltersTooltip': 'Clear Custom Filters (de)',
      'filterPanelClearStatusesTooltip': 'Clear Status Filters (de)',
      'filterPanelSearchTooltip': 'Click to Search (de)',
      'filterPanelClearSortingTooltip': 'Clear Sorting (de)',
      'filtersStatusSectionTitle': 'Statuses (de)',
      'filterForm': {
        'title': 'Filter Settings (de)',
        'generalInformation': 'General Information (de)',
        'conditions': 'Conditions (de)',
        'saveFilter': 'Save Filter (de)',
        'deleteFilter': 'Delete Filter (de)',
        'fieldLabelName': 'Name (de)',
        'fieldLabelVisibility': 'Visibility (de)',
        'visibilityPrivate': 'Private (de)',
        'visibilityAdmins': 'Admins (de)',
        'visibilityAllUsers': 'All Users (de)',
        'advancedMode': 'Advanced mode (de)',
        'addNewCondition': 'Add New Condition (de)',
        'advancedTooltip':
          'Operators: LIKE, NOT_LIKE, EQUAL, NOT_EQUAL, IN, NOT_IN, EMPTY, NOT_EMPTY\n' +
          'Keywords: AND, OR\n\n' +
          'Example:\n' +
          'title LIKE "test" OR severity IN 5,4,3 (de)',
        'resultExpression': 'Result Expression (de)',
        'resultExpressionText': 'Show when {{- query}} (de)',
        'table': {
          'field': 'field (de)',
          'operator': 'operator (de)',
          'value': 'value (de)',
        },
        'allFieldsLabel': 'Ticket Fields (de)',
        'dynamicFieldsLabel': 'Dynamic Options (de)',
        'selectFieldPlaceholder': 'select field (de)',
        'selectOperatorPlaceholder': 'select operator (de)',
        'selectValuePlaceholder': 'select value (de)',
        'optionLabels': {
          'is_me': 'Is Me (de)',
          'my_company': 'My Company (de)',
        },
        'removeConditionTooltip': 'Remove Condition (de)',
      },
    },
    'ticketProvidersListPage': {
      'greeting': 'Welcome (de)',
      'selectTicketProvider': 'Select a Ticket Provider... (de)',
    },
    'scrollableTabsPanel': {
      'noTicketingSystems': 'There is no Ticketing Systems by this Provider (de)',
      'provider': 'Provider (de)',
    },
    'partnerOauthAppsPage': {
      'pageHeader': 'Manage Oauth Applications (de)',
      'newApplication': 'New Application (de)',
      'removeAppTitle': 'Remove Oauth Application (de)',
      'removeAppMessage': 'Are you sure you want to remove \'{{ oauthAppName }}\' Oauth Application? (de)',
      'addNewApp': 'Add New Application (de)',
      'nameLabel': 'name (de)',
      'expiresIn': 'Token Expires In (de)',
      'expiresInTooltip': 'Token TTL in seconds (de)',
      'secretModal': {
        'title': '{{name}} Secret (de)',
        'notification': 'The Secret is only visible once here. You can copy it for further use. (de)',
        'copyButton': 'Copy Secret (de)',
        'secret': 'secret (de)',
        'copiedTooltip': 'Secret copied to clipboard (de)',
      },
      'table': {
        'name': 'Name (de)',
        'createdAt': 'Created At (de)',
      },
    },
    'mimeTypeCollectionsPage': {
      'pageHeader': 'Mime Type Collections (de)',
      'addEntity': 'Add Mime Type Collection (de)',
      'tableHeaderName': 'Mime Type Collection Name (de)',
      'manageMimeTypes': 'Manage Mime Types (de)',
      'formFieldName': 'Name (de)',
      'namePlaceholder': 'Please enter Mime Type Collection name (de)',
      'rightSideBar': {
        'title': 'DETAILS (de)',
        'sectionUsedBy': 'Used By (de)',
        'sectionUsedByTicketProvider': 'Ticket Providers (de)',
      },
      'settingsModal': {
        'title': 'Mime Type Collection Settings (de)',
      },
      'removeEntity': 'Remove Mime Type Collection (de)',
      'removeEntityMessage': 'Are you sure you want to remove \'{{- mimeTypeCollectionName }}\' mime type collection? (de)',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticket providers (de)',
    },
    'mimeTypeCollectionPage': {
      'importMimeTypeCollection': 'Import Mime Type Collection (de)',
      'pageHeader': 'Mime Type Collection (de)',
      'addEntity': 'Add Mime Type (de)',
      'tableHeaderName': 'Mime Type Name (de)',
      'formFieldName': 'Name (de)',
      'namePlaceholder': 'Please enter Mime Type name (de)',
      'rightSideBar': {
        'title': 'DETAILS (de)',
      },
      'settingsModal': {
        'title': 'Mime Type Settings (de)',
      },
      'removeEntity': 'Remove Mime Type (de)',
      'removeEntityMessage': 'Are you sure you want to remove \'{{- mimeType }}\' mime type? (de)',
    },
    'webhookEventsPage': {
      'header': 'Webhook Events (de)',
      'webhookEventsCount_one': '{{count}} webhook event (de)',
      'webhookEventsCount_other': '{{count}} webhooks events (de)',
      'executeWebhookTooltip': 'Execute Webhook Event (de)',
      'markAsIgnoredTooltip': 'Mark as ignored (de)',
      'redirectToRequestsTooltip': 'Requests for Webhook (de)',
      'retryEventsLink': 'Versuchen Sie fehlgeschlagene Ereignisse erneut',
      'retryFailedEventsValue': 'Versuchen Sie fehlgeschlagene Webhook-Ereignisse erneut',
      'retryFailedEventsValueText': 'Bitte bestätigen Sie, dass Sie {{count}} Webhook-Ereignisse für {{numbers}} Ticket(s) wiederholen möchten?',
      'filterPanelTitle': 'Filters (de)',
      'filterPanelTitleTooltip': 'Click to open Filter sidebar (de)',
      'filterPanelFiltersTooltip': 'Active Filters (de)',
      'clearAllFiltersTootltip': 'Clear Filters (de)',
      'clearFilterTooltip': 'Clear "{{filterName}}" Filter (de)',
      'filters': {
        'ticketNumber': 'Ticket ID (de)',
        'action': 'Action (de)',
        'state': 'State (de)',
        'correlationId': 'Correlation ID (de)',
        'externalEventId': 'External Event ID (de)',
        'webhookId': 'Webhook ID (de)',
        'entitySysId': 'Entity Sys ID (de)',
        'webhookParams': 'Webhook Params (de)',
        'executedStartDate': 'Last Executed At Start Date (de)',
        'executedEndDate': 'Last Executed At End Date (de)',
        'allStates': 'all states (de)',
        'allActions': 'all actions (de)',
        'statePending': 'pending (de)',
        'stateProcessing': 'processing (de)',
        'stateSuccessful': 'successful (de)',
        'stateFailed': 'failed (de)',
        'stateInRetry': 'in retry (de)',
        'stateDuplicate': 'duplicate (de)',
        'stateIgnored': 'ignored (de)',
        'actionTypeUnknown': 'unknown (de)',
        'actionTypeCreateTicket': 'create ticket (de)',
        'actionTypeUpdateTicket': 'update ticket (de)',
        'actionTypeCreateComment': 'create comment (de)',
        'actionTypeCreateAttachment': 'create attachment (de)',
      },
      'search': {
        'placeholder': 'Type ticket number (de)',
      },
      'table': {
        'headerId': 'Id (de)',
        'headerTicketId': 'Ticket Id (de)',
        'headerActionType': 'Action (de)',
        'headerState': 'State (de)',
        'headerCtn': 'Ctn (de)',
        'headerCreatedAt': 'Created At (de)',
        'headerLastExecutedAt': 'Last executed at (de)',
        'headerRequestCount': 'Request Count (de)',
      },
      'rightSideBar': {
        'header': 'Webhook Event Details (de)',
        'sectionId': 'Id (de)',
        'sectionState': 'State (de)',
        'sectionTicketId': 'Ticket Id (de)',
        'sectionParams': 'Webhook Params (de)',
        'sectionCreatedAt': 'Created At (de)',
        'sectionLastExecutedAt': 'Last executed at (de)',
        'sectionRequestCount': 'Request Count (de)',
        'externalEventId': 'External Event Id (de)',
        'sectionCtn': 'Ctn (de)',
        'entitySysId': 'Entity sys Id (de)',
        'correlationID': 'Correlation Id (de)',
        'lastResponsePayload': 'last Response Payload (de)',
        'errorMessage': 'Error Message (de)',
      },
    },
    'satCompliance': {
      'compliant': 'Compliant (de)',
      'soonOutOfCompliance': 'Soon Out of Compliance (de)',
      'outOfCompliance': 'Out of Compliance (de)',
      'notUsed': 'Not Used (de)',
      'disabled': 'Disabled (de)',
    },
    'satClientsPage': {
      'pageHeader': 'SAT Clients (de)',
      'syncClients': 'Sync SAT Clients (de)',
      'clientsCount': '{{count}} SAT Clients (de)',
      'filterPanelTitle': 'Filters (de)',
      'filterPanelTitleTooltip': 'Click to open Filters sidebar (de)',
      'filterPanelFiltersTooltip': 'Active Filters (de)',
      'clearAllFiltersTooltip': 'Clear Filters (de)',
      'clearFilterTooltip': 'Clear "{{filterName}}" Filter (de)',
      'filters': {
        'clientId': 'SAT Client ID (de)',
        'capabilities': 'Capabilities (de)',
        'partner': 'Partner (de)',
        'enabled': 'Enabled (de)',
        'approved': 'Approved (de)',
        'compliance': 'Compliance (de)',
        'expiresAtStartDate': 'Expires At Start Time (de)',
        'expiresAtEndDate': 'Expires At End Time (de)',
        'lastUsedAtStartDate': 'Last Used At Start Time (de)',
        'lastUsedAtEndDate': 'Last Used At End Time (de)',
      },
      'table': {
        'id': 'ID (de)',
        'clientID': 'Client ID (de)',
        'partner': 'Partner (de)',
        'enabled': 'Enabled (de)',
        'approved': 'Approved (de)',
        'capabilities': 'Capabilities (de)',
        'compliance': 'Compliance (de)',
        'openSatSecretsTooltip': 'Manage SAT Secrets (de)',
        'openManagersModalTooltip': 'Open Managers (de)',
      },
      'rightSideBar': {
        'header': 'SAT Client Details (de)',
        'sectionClientId': 'Client ID (de)',
        'sectionCompliance': 'Compliance (de)',
        'sectionPartner': 'Partner (de)',
        'sectionDescription': 'Description (de)',
        'sectionCapabilities': 'Capabilities (de)',
        'sectionEnabled': 'Enabled (de)',
        'sectionApproved': 'Approved (de)',
        'sectionManagers': 'Managers (de)',
        'sectionCreatedAt': 'Created At (de)',
        'sectionUpdatedAt': 'Updated At (de)',
        'sectionSecrets': 'Secrets (de)',
        'secretsColumns': {
          'lastFour': 'Last Four (de)',
          'active': 'Active (de)',
          'expiresAt': 'Expires At (de)',
          'compliance': 'Compliance (de)',
        },
      },
      'managersModal': {
        'title': 'Set Managers (de)',
        'label': 'Manager List (de)',
        'placeholder': 'Enter user login or email (de)',
      },
    },
    'satSecretsPage': {
      'pageHeader': 'SAT Secrets (de)',
      'addSecret': 'Add New Secret (de)',
      'addConfirmDialogTitle': 'Confirm (de)',
      'addConfirmDialogMsg': 'Are you sure you want to generate a new secret? This will take effect immediately! (de)',
      'table': {
        'lastFour': 'Last Four (de)',
        'active': 'Active (de)',
        'compliance': 'Compliance (de)',
        'expiresAt': 'Expires At (de)',
        'lastUsedAt': 'Last Used At (de)',
        'disableSecretTooltip': 'Mark as disabled (de)',
        'disableConfirmDialogTitle': 'Confirm Disabling of Client Secret (de)',
        'disableConfirmDialogMsg': 'Are you sure you want to disable the secret? (de)',
      },
      'secretModal': {
        'title': 'New Secret Generated (de)',
        'notification': 'The Secret is only visible once here. You can copy it for further use. (de)',
        'copyButton': 'Copy Secret (de)',
        'copiedTooltip': 'Secret copied to clipboard (de)',
      },
    },
    'providerCredentialsPage': {
      'pageHeader': 'Provider Credentials (de)',
      'addEntity': 'Add Provider Credential (de)',
      'tableHeader': {
        'name': 'Name (de)',
        'credentialType': 'Credential Type (de)',
        'autorotation': 'Autorotate Secrets (de)',
        'nextRotationDate': 'Next Rotation Date (de)',
      },
      'formFieldName': 'Name (de)',
      'namePlaceholder': 'Please enter Provider Credential name (de)',
      'formFieldCredentialType': 'Credential Type (de)',
      'credentialTypePlaceholder': 'Please select Credential Type (de)',
      'rightSideBar': {
        'title': 'DETAILS (de)',
        'sectionUsedBy': 'Used By (de)',
        'sectionUsedByTicketProvider': 'Ticket Providers (de)',
      },
      'settingsModal': {
        'title': 'Provider Credential Settings (de)',
      },
      'removeEntity': 'Remove Provider Credential (de)',
      'removeEntityMessage': 'Are you sure you want to remove \'{{- providerCredentialName }}\' Provider Credential? (de)',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticket providers (de)',
    },
    'confirmDialog': {
      'justificationLabel': 'Justification: (de)',
      'justificationPlaceholder': 'Enter justification here (de)',
    },
  },
}

export default de
